import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#basic-usage" }),
  /*#__PURE__*/_createTextVNode(" Basic usage ")
], -1)
const _hoisted_3 = { class: "rounded border p-10" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Tag 1")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Tag 2")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Tag 3")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Tag 4")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Tag 5")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_el_tag, null, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_el_tag, { type: "success" }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_el_tag, { type: "info" }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }),
      _createVNode(_component_el_tag, { type: "warning" }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }),
      _createVNode(_component_el_tag, { type: "danger" }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code1), 1)
        ]),
        _: 1
      })
    ])
  ]))
}